import { init, loaderRunner, userLoggedIn } from "./helpers";

export const loginLoader = async () => {
  return loaderRunner([await init(), await userLoggedIn()]);
};
